'use es6';

// Provides two way conversions between external formats and Filter Query Format
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getAssociationTypeId", "getAssociationCategory"];
import * as DSAssetFamilies from 'customer-data-filters/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { Map as ImmutableMap } from 'immutable';
import { fromListSegClassic } from './listSegClassic/fromListSegClassic';
import { toListSegClassic } from './listSegClassic/toListSegClassic';
import { fromObjectSeg_XO, toObjectSeg_XO } from './objectSeg/FilterObjectSeg_XO';
import MissingField from '../filterQueryFormat/MissingField';
const getOptions = (options = {}) => Object.assign({
  baseFilterFamily: undefined,
  getField: pathArr => MissingField({
    name: pathArr[pathArr.length - 1]
  })
}, options);
const provideAssociationsContext = (func, data) => {
  if (!func) {
    return func;
  }
  const associations = data.get(DSAssetFamilies.ASSOCIATION_DEFINITION);
  return function (fromObjectTypeId, toObjectTypeId, logicGroup) {
    return func(fromObjectTypeId, toObjectTypeId, logicGroup, associations);
  };
};
export function DSFilterFromObjectSeg(value, baseFilterFamily, getField, isUngated, options = {}) {
  return fromObjectSeg_XO(value, baseFilterFamily, getField, isUngated, Object.assign({
    useDSFilterFamilies: true
  }, options));
}
export function DSFilterToObjectSeg(value, isUngated, data = ImmutableMap(), options = {}) {
  const {
      getAssociationTypeId,
      getAssociationCategory
    } = options,
    rest = _objectWithoutPropertiesLoose(options, _excluded);
  return toObjectSeg_XO(value, isUngated, Object.assign({
    getAssociationCategory: provideAssociationsContext(getAssociationCategory, data),
    getAssociationTypeId: provideAssociationsContext(getAssociationTypeId, data),
    useDSFilterFamilies: true
  }, rest));
}
export function DSFilterFromListSegClassic(value, baseFilterFamily, getField, __isUngated, options = {}) {
  const {
    constraint
  } = getOptions(options);
  return fromListSegClassic(getField, value, baseFilterFamily, constraint);
}
export function DSFilterToListSegClassic(value, __isUngated, __data = ImmutableMap(), options = {}) {
  const {
    constraint
  } = getOptions(options);
  return toListSegClassic(value, constraint);
}